export default __webpack_public_path__ + "static/media/fin.e5249649.svg";